export default "__VITE_ASSET__DUTu9ARN__"